export default function refID(ref) {
  return ref.split('-')[1];
}
